/* istanbul ignore file */
import { FieldProps, TextField, useFieldHelper } from 'framework/ui/field';
import { PROBABILITY_MAP } from 'domain/sales/opportunity/opportunityService';

const OpportunityProbabilityField = (props: FieldProps) => {
  const { getValue } = useFieldHelper(props);
  const value = getValue();
  const displayedValue = value ? `${PROBABILITY_MAP[value]}%` : null;

  return <TextField {...props} value={displayedValue} />;
};

export default OpportunityProbabilityField;
